import React, { FC } from 'react';
import { Switch, useTheme } from '@mui/material';
import DarkModeIcon from '@mui/icons-material/DarkMode';
import {
  SHIFT_TYPE_NIGHT,
  SHIFT_TYPE_NORMAL,
} from '../../../utils/variables/shift';
import classes from './NightShiftToggle.module.scss';

//夜勤(2直)トグル。仕様 01-frontend.md §4。単体・一括の両ヘッダーから利用する共通コンポーネント。
//「通常勤務」という語は出さず、夜勤かどうかだけを意識させる。
//色はアプリ標準の青(theme.palette.foreColor.main)に統一する(30分休スイッチ等の他コンポーネントと同様)。

const OFF_COLOR = '#8d94a2';

type NightShiftToggleProps = {
  shiftType: number; // 0 | 1
  onChange: (next: number) => void;
  disabled: boolean; // fromTime < 12:00 のとき操作不可
};

const NightShiftToggle: FC<NightShiftToggleProps> = ({
  shiftType,
  onChange,
  disabled,
}) => {
  const theme = useTheme();
  const nightColor = theme.palette.foreColor.main; //夜勤アクセント=標準の青
  const isNight = shiftType === SHIFT_TYPE_NIGHT;
  const accent = disabled ? OFF_COLOR : isNight ? nightColor : OFF_COLOR;
  return (
    <div className={classes.rootContainer}>
      <p className={classes.label} style={{ color: accent }}>
        夜勤
      </p>
      <Switch
        checked={isNight}
        disabled={disabled}
        onChange={() =>
          onChange(isNight ? SHIFT_TYPE_NORMAL : SHIFT_TYPE_NIGHT)
        }
        sx={{
          '& .MuiSwitch-switchBase.Mui-checked': {
            color: nightColor,
          },
          '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
            backgroundColor: nightColor,
          },
        }}
      />
      <DarkModeIcon
        fontSize="small"
        className={classes.icon}
        style={{ color: accent, opacity: disabled ? 0.4 : 1 }}
      />
    </div>
  );
};

export default NightShiftToggle;
